module.exports = __webpack_public_path__ + "img/workbench_nothing_bar.af9ef78c.png";